"use client";

import { MobileSidebarToggle } from "@/components/mobile-sidebar-toggle";

type PowerOnProLayoutProps = {
  children: React.ReactNode;
};

export default function PowerOnProLayout({ children }: PowerOnProLayoutProps) {
  return (
    <>
      <MobileSidebarToggle layoutName="PowerOn Pro" />
      <div className="mx-auto mb-20 mt-7 max-w-5xl">{children}</div>
    </>
  );
}
